'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (component) {
	var firstProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	return function (mainProps) {
		return _react2.default.createElement(_component2.default, _extends({}, firstProps, mainProps, { component: component }));
	};
};


//////////////////
// WEBPACK FOOTER
// ./~/react-lifecycle-component/lib/applyLifecycle.js
// module id = 435
// module chunks = 0